import { render, staticRenderFns } from "./AwardStep.vue?vue&type=template&id=a925344a&scoped=true&"
import script from "./AwardStep.vue?vue&type=script&setup=true&lang=js&"
export * from "./AwardStep.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AwardStep.vue?vue&type=style&index=0&id=a925344a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a925344a",
  null
  
)

export default component.exports